
import Vue from "vue";
import draggable from "vuedraggable";
import { Component, Prop } from "vue-property-decorator";
import {
  Control,
  decorateValueEmittedByInputWithMetadata
} from "@/types/controls";

import defensiveCopy from "@/util/defensive-copy";
import RepeaterItemTitleText from "@/components/Reusable/CustomInputs/Repeater/RepeaterItemTitleText.vue";
import Icon from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: {
    NiceButton,
    Icon,
    RepeaterItemTitleText,
    draggable
  }
})
export default class InlineRepeater extends Vue {
  @Prop()
  control!: Control;

  @Prop()
  value!: unknown[];

  @Prop({ default: false })
  createSnapshotWhenItemsListChanges!: boolean;

  @Prop()
  defaultNewValue!: unknown;

  @Prop({ default: false })
  groupedInputs!: boolean;

  beforeCreate() {
    // @ts-ignore
    this.$options.components.ControlsTree =
      require("@/components/Reusable/ControlsTree/ControlsTree.vue").default;
  }

  dragOptions = {
    animation: 200,
    handle: ".breakdance-inline-repeater-drag-handle",
    ghostClass: "breakdance-inline-repeater-item--ghost",
    forceFallback: true
  };

  get buttonName() {
    return this.control?.options.repeaterOptions?.buttonName || "Add new";
  }

  emit(newValue: unknown) {
    this.$emit(
      "input",
      this.createSnapshotWhenItemsListChanges
        ? decorateValueEmittedByInputWithMetadata(newValue, {
            disableTransactionBundling: true
          })
        : newValue
    );
  }

  handleDrag(newValue: unknown) {
    this.emit(defensiveCopy(newValue));
  }

  addItem() {
    const repeaterData: Array<unknown> = defensiveCopy(this.value) || [];
    repeaterData.push(this.defaultNewValue || {});

    this.emit(repeaterData);
  }

  deleteItem(index: number) {
    const repeaterData = defensiveCopy(this.value) || [];
    repeaterData.splice(index, 1);

    this.emit(repeaterData);
  }
}
